import React, { useRef, useState } from 'react';
import css from './ListPLTS.module.scss';
import { NavLink } from "react-router-dom";
import ATable from '../../../Components/ATable/ATable';
import { getListPLTS } from '../../../Services/Admin/PLTS';
import SettingTable from '../../../Components/ATable/SettingTable';
const ListPLTSPage = () => {
    const aTable = useRef();
    const role_code = localStorage.getItem("role_code_admin");
    // alert(role_code)
    let columns = [
        {title: "No", field: "no", align: "center", sortable: true},
        {title: "Station Code", field: "station_code", align: "left", sortable: true},
        {title: "User", field: "station_name", align: "left", sortable: true},
        {title: "Group", field: "group_id", align: "center", sortable: true },
        {title: "Status", field: "status", align: "center", sortable: true, status_station: true},
        {title: "Consumption", field: "consumption", round:true, align: "left", sortable: true},
        {title: "Total Yield", field: "total_yield", round:true, align: "left", sortable: true},
        {title: "Total Revenue", field: "revenue", round:true, align: "left", sortable: true},
        {
            title: "Action", 
            field: "action", 
            align: "center", 
            sortable: true, 
            type:'action', 
            link: '/admin/list-plts/edit-plts',
            value: <i class="fi fi-rr-edit"></i>,
            primary :'station_code',
            admin: true,   
        }
    ];
    

    const settingTable = {
        admin:false,
        columns,
        FilterSearchAll : true,
        CreateButtonWithLink : '/admin/list-plts/add-plts',
        ValueSearch : '',
        filter:true,
        roleCode: role_code,   
    };

    

    return (
        <div className='wrap_admin'>
            <div className='row vh-100'>
                <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>

                    <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                        <SettingTable columns={columns} data={getListPLTS} {...settingTable} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListPLTSPage;
